export default __webpack_public_path__ + "static/media/p5.270a7e4d.jpg";